import { Component, OnInit } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { EstacionesTVADB } from 'src/app/DAO/EstacionesTVADB';
import { TblCatUsuario } from 'src/app/types/Tables';
import { MenuItem, SettingsCollection } from 'src/app/types/type';
import { LoginService } from 'src/app/services/login.service';
import { Usuario } from 'src/app/types/Entitys';
import { catchError, switchMap, throwError } from 'rxjs';
import { Utilerias } from 'src/app/helpers/Utilerias';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  idEmpleado: number;
  db: EstacionesTVADB;
  userSesion: TblCatUsuario;
  menus: any;
  disableBtn: boolean = false;
  isDev: boolean = true;

  constructor(private router: Router, private loginService: LoginService) { }

  ngOnInit() {
    if (environment.production)
      this.isDev = false;

    this.IngresoOkta();
  }

  formLogin() {
    this.LoginServer();
  }

  private IngresoOkta() {
    debugger
    this.loginService.getSettings()
      .subscribe(response => {
        if (response?.Result?.Exito) {
          const data = response.Result.Data as SettingsCollection
          if (data.debug === "false") {
            localStorage.clear();
            window.location.href = data.login_Domain + data.login_LogOut
          }
        }
      });
  }

  private LoginServer() {
    this.disableBtn = true;

    const body = {
      IdEmpleado: this.idEmpleado,
      Token: localStorage['acTkn'],
      IdTipoAplicacion: 1
    };

    this.loginService.login(body)
      .pipe(
        catchError((error: HttpErrorResponse) => {
          Swal.fire({
            text: error.message,
            allowEnterKey: false,
            allowEscapeKey: false,
            showConfirmButton: true,
            allowOutsideClick: false
          })
          this.disableBtn = false;
          this.IngresoOkta();
          return throwError(() => new Error(`!No se pudo iniciar sesión! - ${error.message}`))
        })
      )
      .pipe(
        switchMap(
          async resp => {
            if (resp?.Result?.Exito) {
              const data = resp.Result.Data as Usuario;

              localStorage.jwt = data.Token;
              localStorage.IdEmpleado = data.IdEmpleado;
              localStorage.Browser = data.Browser;
              localStorage.Token = data.Token;
              localStorage.IpSesion = data.IpSesion;
              localStorage.Roles = JSON.stringify(data.Roles);
              localStorage.Rol = data.Roles[0].IdRol + '-' + data.Roles[0].Descripcion;
              
              this.db = new EstacionesTVADB();
              await this.db.postLocalobject('TblCatUsuario', data);

              return data.IdEmpleado;
            } else {
              this.disableBtn = false;
              Utilerias.alertClient('', resp.Result.Error, 1);
              throw resp.Result.Error;
            }
          }
        )
      )
      .subscribe(idEmpleado => {
        this.loginService.getCatalogoMenus(idEmpleado)
          .subscribe(resp => {
            if (resp.Result.Exito) {
              const data = resp.Result.Data as MenuItem[]
              const page = data.length > 0 ? data[0] : null;
              
              this.router.navigate([`/${page.ComponentName}`]);
              this.disableBtn = false;
            }
          });
      });
  }

  userInfo() {
    if ($('#dropdown-menu').is(':visible')) {
      $('#dropdown-menu').fadeOut();
    } else {
      $('#dropdown-menu').fadeIn();
    }
  }
}
